import { useEffect, useState } from 'react'
import { SearchDropdown } from '@prosolve/common-components-ui'
import useShipmentSnackbar from './useShipmentSnackbar';
import useFetchOpportunities from './useFetchOpportunities';
import OptionalFormFieldWrapper from './OptionalFormFieldWrapper';

export default ({
  accountId,
  value: defaultValue,
  onChange: onChangeParam = () => {}
}) => {
  const { fetchOpportunities: fetchOpportunitiesHook } = useFetchOpportunities()

  const [value, setValue] = useState(defaultValue)
  const [searchVal, setSearchVal] = useState(defaultValue)
  const [isLoading, setIsLoading] = useState(false)
  const [opportunities, setOpportunities] = useState()

  const shipmentSnackbar = useShipmentSnackbar()

  const filteredOpportunities = opportunities?.map(a => {
    return {
      text: a.Name,
      value: a.Id,
    }
  })
  const mappedOpportunities = opportunities?.reduce((acc, cur) => { acc[cur.Id] = cur; return acc; }, [])

  const fetchOpportunities = async () => {
    setIsLoading(true)
    try {
      const resultJson = await fetchOpportunitiesHook({ limit: 50, name: searchVal, accountId })
      setOpportunities(resultJson)
    } catch (e) {
      console.error(e)
      shipmentSnackbar.newMessage({ message: 'Error getting opportunities', severity: 'failure' })
    } finally {
      setIsLoading(false)
    }
  }

  const onChange = (val) => {
    setValue(val)
    onChangeParam(val, { id: val, opportunity: mappedOpportunities?.[val] }) 
  }

  useEffect(() => {
    fetchOpportunities()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchVal, accountId])

  // Prevent the document behind the popup from scrolling
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column'}}>
      <OptionalFormFieldWrapper isEnabled={true} label={'Opportunity'}>
        <SearchDropdown
          value={value}
          options={filteredOpportunities}
          onChange={(val) => onChange(val) }
          onSearch={(val) => setSearchVal(val)}
          isLoading={isLoading}
          maxHeight='200px'
          width='350px'
        />
      </OptionalFormFieldWrapper>
    </div>
  )
}